import { AiButton } from "@/modules/ai/features/manipulate-text/ui/ai-button";
import { ButtonProps } from "@/shared/form/button";
import { useGeneratePostTitle } from "@/modules/ai/features/generate-post-title/model/use-generate-post-title";
import { useEffect } from "react";

export type GeneratePostTitleProps = ButtonProps & {
  setTitle: (title: string | undefined) => void;
  postBody: string;
};

export function GeneratePostTitle({
  postBody,
  setTitle,
  ...props
}: GeneratePostTitleProps) {
  const { generate, title, loading } = useGeneratePostTitle();

  useEffect(() => {
    setTitle(title);
  }, [title]);

  return (
    <AiButton
      {...props}
      loading={loading}
      onClick={() => {
        generate(postBody);
      }}
    />
  );
}
